import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CAMPAIGN_END = new Date('2026-03-31T23:59:59+09:00');

export default function CampaignMiniBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calc = () => {
      const diff = CAMPAIGN_END.getTime() - Date.now();
      if (diff <= 0) {
        setIsExpired(true);
        return;
      }
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / 1000 / 60) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };
    calc();
    const t = setInterval(calc, 1000);
    return () => clearInterval(t);
  }, []);

  if (dismissed || isExpired) return null;

  return (
    <div className="bg-gradient-to-r from-[#2D2D2D] via-[#3A3A3A] to-[#2D2D2D] border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-2.5 sm:py-3 relative">
        <div className="flex items-center justify-center gap-3 sm:gap-5 pr-8">
          <span className="bg-[#C45C5C] text-white text-[9px] sm:text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
            お知らせ
          </span>
          <span className="text-xs sm:text-sm font-medium text-white whitespace-nowrap">
            3/1より価格改定
          </span>
          <div className="hidden sm:flex items-center gap-1 bg-white/10 px-3 py-1 rounded-full text-white text-xs font-light">
            <span className="opacity-70 mr-1">残り</span>
            <span>{timeLeft.days}日</span>
            <span className="opacity-40">:</span>
            <span>{String(timeLeft.hours).padStart(2, '0')}</span>
            <span className="opacity-40">:</span>
            <span>{String(timeLeft.minutes).padStart(2, '0')}</span>
            <span className="opacity-40">:</span>
            <span className="text-[#FF8A8A]">{String(timeLeft.seconds).padStart(2, '0')}</span>
          </div>
          <span className="text-[10px] sm:text-xs text-white/60 hidden md:inline">
            3/31まで<strong className="text-[#F5D6A0]">価格維持予約</strong>＋ギフト券5,000円
          </span>
          <Link
            to="/campaign"
            className="inline-flex items-center gap-1 bg-white hover:bg-white/90 text-[#2D2D2D] text-[11px] sm:text-xs font-medium px-3 sm:px-4 py-1.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            予約する
            <i className="ri-arrow-right-line text-xs" aria-hidden="true"></i>
          </Link>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="absolute top-1/2 right-2 sm:right-4 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-white/40 hover:text-white/80 transition-colors cursor-pointer"
          aria-label="バナーを閉じる"
        >
          <i className="ri-close-line text-base" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
}
